export default retractModalCtrl

/** @ngInject */
function retractModalCtrl($scope, $rootScope, $state, $uibModalInstance, Contract, contractId, AlertManager, ErrorCatcher) {
    $scope.close = $uibModalInstance.dismiss

    $scope.confirmRetractation = () =>
        Contract.retract({ id: contractId }).$promise
        .then((response) => {
            window.location.reload()
            $scope.close()
        })
        .catch((error) => {
            AlertManager.addAlert({
                type: 'error',
                msg: `Une erreur s'est produite. Essayer de recharger la page. ${error.data.message}`,
                timeout: 30000,
            })
            return ErrorCatcher.catchError(error)
        })
}



// WEBPACK FOOTER //
// ./src/states/account/modal/retractModal.js